// extracted by mini-css-extract-plugin
export default {"footer":"styles__footer___I-PEh","icon":"styles__icon___yCjYO"};